import { FieldKey } from '@core/data-access/models/dynamic-form-field/dynamic-form-field.model';
import { FormField } from '@core/data-access/models/form/form-store.model';
import { BuyerInformationStoreState } from '@core/features/buyer-information/models/buyer-information-store.model';
import { buyerInformationReducerKey } from '@core/features/buyer-information/store/buyer-information.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { defaultTo } from 'lodash';

const buyerInformationFeatureSelector = createFeatureSelector<BuyerInformationStoreState>(buyerInformationReducerKey);

export const selectBuyerPerson = createSelector(buyerInformationFeatureSelector, ({ person }) => person);

export const selectBuyerPersonId = createSelector(buyerInformationFeatureSelector, ({ person }) => person.id);

export const selectBuyerInformationForm = createSelector(
  buyerInformationFeatureSelector,
  ({ forms }) => forms.buyerInformation
);

export const selectIsBuyerInformationFormPrefilled = createSelector(
  selectBuyerInformationForm,
  ({ isPrefilled }) => isPrefilled
);

export const selectBuyerInformationFormFields = createSelector(
  selectBuyerInformationForm,
  ({ formFields }) => formFields
);

export const selectBuyerInformationEmailAddress = createSelector(selectBuyerInformationFormFields, (formFields) =>
  defaultTo((formFields[FieldKey.Email] as FormField)?.value as string, '')
);

export const selectBuyerBillingAddressForm = createSelector(
  buyerInformationFeatureSelector,
  ({ forms }) => forms.buyerBillingAddress
);

export const selectSelectedSavedBillingAddressId = createSelector(
  selectBuyerBillingAddressForm,
  ({ selectedSavedBillingAddressId }) => selectedSavedBillingAddressId
);

export const selectBuyerBillingAddressFormFields = createSelector(
  selectBuyerBillingAddressForm,
  ({ formFields }) => formFields
);

export const selectBuyerPrivacyPolicyForm = createSelector(
  buyerInformationFeatureSelector,
  ({ forms }) => forms.buyerPrivacyPolicy
);

export const selectBuyerPrivacyPolicyFormFields = createSelector(
  selectBuyerPrivacyPolicyForm,
  ({ formFields }) => formFields
);
